import 'reflect-metadata';
import { Service } from 'typedi';
import type { CardTypeStrategyData } from '../../types/card-strategy-data.type';
import type { SearchApiDocument } from '../../../../api/model/response/documents/SearchResult';
import { StrategyBuilder } from '../../StrategyBuilder';
import { CardStrategyService } from '../../CardStrategyService';

@Service({ id: 'circularEconomyCardStrategyService' })
export class CircularEconomyCardStrategyBuilder extends StrategyBuilder<CardStrategyService> {
  build(details: CardTypeStrategyData): CardStrategyService {
      return new CircularEconomyCardStrategyService(details);
  }
}

export class CircularEconomyCardStrategyService extends CardStrategyService {
  details;
  constructor(details: CardTypeStrategyData) {
      super();
      this.details = details;
  }

  productCardSources = [
    'ECAT_BSL',
    'ECAT_BSL_SUB',
    'CLIPSAL',
    'NAV_PES',
    'FAMILY_PES',
    'OFFER_PES',
    'PRD_SDLPAGE',
    'OFFER_PROMOTED',
    'ORACLE_CROSSREF',
  ];

  makeCard(doc: SearchApiDocument): string {
      switch (true) {
      case this.productCardSources.includes(doc.source):
        return 'uiaas-search-result-product';
      default:
        return 'uiaas-search-result-circular';
      }
  }

  getCardProps(
    doc: SearchApiDocument,
    params: Record<string, string>
  ): Record<string, string> {
      if (this.details?.params) {
        return this.details.params;
      }
      return {};
  }
}
